import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as l, normalizeClass as n, createElementVNode as i } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconWind",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ i("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9.869 4.016a.75.75 0 0 0-.672.194.5.5 0 0 1-.694-.72 1.75 1.75 0 1 1 1.26 3.01H1a.5.5 0 1 1 0-1h8.743a.75.75 0 0 0 .126-1.484Z",
  "clip-rule": "evenodd"
}, null, -1), u = /* @__PURE__ */ i("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.61 2.51a.5.5 0 0 0-.453.14.5.5 0 1 1-.714-.7A1.5 1.5 0 1 1 5.497 4.5H1a.5.5 0 1 1 0-1h4.507a.5.5 0 0 0 .103-.99ZM6.997 7.5a1.5 1.5 0 1 1-1.054 2.55.5.5 0 1 1 .714-.7.5.5 0 1 0 .35-.85H1a.5.5 0 0 1 0-1h5.997Z",
  "clip-rule": "evenodd"
}, null, -1), h = [
  _,
  u
];
function m(a, f, d, p, v, e) {
  return l(), r("svg", {
    "aria-label": d.ariaLabel,
    class: n([e.iconSizeClass, "d-icon d-icon--wind"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Wind",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, h, 10, c);
}
const C = /* @__PURE__ */ o(s, [["render", m]]);
export {
  C as default
};
//# sourceMappingURL=wind.js.map
